import { styled } from '@mui/material';
import TextFieldCommon from '@mui/material/TextField';

export const TextField = styled(TextFieldCommon)`
  & input:focus {
    border: none;
  }
`;
